<!--
 * @Author: your name
 * @Date: 2021-12-07 15:40:36
 * @LastEditTime: 2022-01-10 17:39:30
 * @LastEditors: Please set LastEditors
 * @Description: 加入我们
 * @FilePath: \new-website-1123\src\views\service\joinus\index.vue
-->
<template>
  <div class="service-joinus">
    <!--banner-->
    <div
      class="contactus-us"
      :style="{
        backgroundImage: 'url(' + banner + ')',
        'background-size': 'cover',
      }"
    >
      <div class="contactus-us-view">
        <div class="contactus-us-infor">
          <h2>向光而生 热爱无限</h2>
          <h4>加入我们，一起用科技领航未来!</h4>
        </div>
      </div>
    </div>

    <!--人才理念-->
    <div class="flexbox concept-connect opacity-page scale-page">
      <div class="flexbox-item">
        <w-title
          model="人才"
          modelkey="理念"
          paragraph="人才是企业发展的源源动力。上太科技格外重视人才的吸引与培养。
公司建立完善的人才内训计划与晋升机制，为优秀人才创造良好的
成长平台，帮助员工在工作生活中充分发挥自身价值。"
          direction="left"
        ></w-title>
      </div>
      <div class="flexbox-item">
        <img src="@/assets/images/service/concept-pic.jpg" />
      </div>
    </div>

    <!-- 员工福利 -->
    <p-advantage
      class="opacity-page"
      :title="{
        text: '员工',
        color: '福利',
      }"
      :dataList="advantageList"
    >
      <template v-slot:paragraph>
        每逢中秋、端午、春节等节日，公司均为员工精心挑选节日礼品，并举行团建活动，增加员工对企业的归属感、同事一家亲的认同感。
      </template>
    </p-advantage>

    <!--加入我们-->
    <div class="recruit-connect opacity-page scale-page">
      <w-title
        model="加入"
        modelkey="我们"
        paragraph="欢迎投递简历至：stkjadmin@stkjiot.com。相信我们可以为你带来一些惊喜！"
      ></w-title>

      <ul class="recruit-connect-ul">
        <li
          v-for="(item, index) in recruit"
          :key="index"
          class="animation-3"
          :class="{ active: changenamber === index }"
          @click="dataListopen(index)"
        >
          <div class="recruit-connect-title flexbox">
            <h2>{{ item.position }}</h2>
            <span class="flexbox-item">{{ item.position_text }}</span>
            <div
              class="openicon iconfont iconxia animation-3"
              :class="{ active: changenamber === index }"
            ></div>
          </div>
          <div class="recruit-connect-view">
            <div
              class="recruit-connect-item"
              v-for="(render, index2) in item.describe"
              :key="index2"
            >
              <h4>{{ render.describe_title }}</h4>
              <p v-html="render.describe_dec"></p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import wTitle from "@/components/sTitle/viewtitle";
import pAdvantage from "../../programme/components/swiper.vue";
export default {
  name: "service-joinus",
  components: {
    wTitle,
    pAdvantage,
  },
  data() {
    return {
      banner: require("../../../assets/images/service/joinus-pic.jpg"),
      changenamber: 1,
      recruit: [
        {
          position: "产品经理",
          position_text: "成都 | 3-5年 | 产品",
          describe: [
            {
              describe_title: "职位描述",
              describe_dec:
                "1. 市场调研：能够与用户或潜在用户交流、研究市场分析报告、试用竞品等途径定期进行市场调研；深度参与产品战略规划及决策；<br />2. 产品设计：从产品规划策略和用户体验出发，独立完成产品功能、流程、用户界面及交互设计，输出产品原型及产品需求文档。同时，协同技术经理完成产品开发计划，明确开发进度及所需资源；<br />3. 产品宣介：向内外部客户进行产品宣介、输出产品宣介文档，包括产品说明书、销售手册等。",
            },
            {
              describe_title: "职位要求",
              describe_dec:
                "1. 本科及以上学历，3年及以上互联网产品经理工作经验；<br />2. 对互联网产品有深入理解，有农业行业相关经验者优先；<br />3. 熟悉建立客户需求分析、客户体验、产品规划、产品设计、客户维护及市场分析；<br />4. 具备独立撰写产品文档的能力，有独立策划并成功上线产品的设计案例；<br />5. 思路清晰、工作细心、逻辑思维能力强；善于研究、思考及总结，有较强的沟通、团队协作及项目协调能力；<br />6. 致力于在农业行业长期发展，能承受产品整体规划及市场推进带来的较大工作压力；<br />7. 自驱力强，渴求通过自身努力不断完善自己以获得自我成长；",
            },
          ],
        },

        {
          position: "技术美术",
          position_text: "成都 | 3-5年 | 研发",
          describe: [
            {
              describe_title: "职位描述",
              describe_dec:
                "1.根据客户需求以及提供的资料进行各类设备与室内外场景的模型和贴图制作，并将模型资源整合进引擎调整场景呈现效果 <br />2.根据需求设计场景中对应的环节动画与展现形式",
            },
            {
              describe_title: "职位要求",
              describe_dec:
                "1.责任心强，对工作负责，为人友好，善于沟通，条理清晰，能够与其它岗位同事有效合作<br />2.熟练使用 Max Maya C4d Blender 中的一款或多款软件进行模型制作<br />3.精通 游戏模型 的制作方式，能够很好地控制及优化模型的面数与贴图大小。<br />4.拥有不错的审美并且能够合理分配模型UV，利用优质贴图来表现模型的纹理质感与体积。<br />5.精通 全手绘贴图 制作流程者优先<br />6.知道次世代模型制作流程 且 熟练使用一款或多款游戏引擎者优先<br />7.够熟练读取或使用 CAD图纸 BIM模型相关软件 SKetchUP AE（特效制作） 等另加分",
            },
          ],
        },
        {
          position: "前端工程师",
          position_text: "成都 | 3-5年 | 研发",
          describe: [
            {
              describe_title: "职位描述",
              describe_dec:
                "1、分析产品需求，完成需求评审会的意见提出和技术方案<br />2、搭建前端环境，适用性，根据项目的未来发展方向进行模块封装等<br />3、对产品设计图提出相关意见，和设计师沟通效果实现等优化用户体验的行为<br />4、研发开发过程中，出现产品逻辑疑问及时提出并沟通解决 完成需求的变更<br />5、保证质量编写代码完成产品开发，与设计图保持一致，具有良好的游览器兼容性等<br />6、编写代码过程中完成动画的设定与优化网站整体加载性能,规避一些产品问题的出现",
            },
            {
              describe_title: "职位要求",
              describe_dec:
                "1、精通HTML5、CSS3、Ajax、JavaScript、jQuery、JSON等前端技术<br />2、熟练使用Vue、ElementUI、NodeJS、three.js等前端框架技术；<br />3、熟练使用SVN、GIT等代码版本管理工具；<br />4、熟悉Echarts、NodeJS、Vue.js、Vue-CLI等前端技术<br />5、熟悉前后端分离开发模式,熟练掌握前端路由和客户端缓存技术<br />6、了解JavaScript闭包、面向对象",
            },
          ],
        },
      ],
      advantageList: [
        {
          key: 1,
          cover: require("../../../assets/images/service/welfare1.jpg"),
        },
        {
          key: 2,
          cover: require("../../../assets/images/service/welfare2.jpg"),
        },
        {
          key: 3,
          cover: require("../../../assets/images/service/welfare3.jpg"),
        },
        {
          key: 4,
          cover: require("../../../assets/images/service/welfare4.jpg"),
        },
        {
          key: 5,
          cover: require("../../../assets/images/service/welfare5.jpg"),
        },
      ],
    };
  },
  created() {},
  computed: {
    currentDevice() {
      return this.deviceList.filter((item) => item.key == this.deviceActive)[0];
    },
  },
  methods: {
    dataListopen(index) {
      var self = this;
      self.changenamber = index;
      console.log(self.changenamber);
    },
  },
};
</script>

<style lang="scss" scoped>
.contactus-us {
  height: 720px;

  .contactus-us-view {
    width: 1200px;
    padding-top: 196px;
    margin: 0 auto;
    .contactus-us-infor {
      color: $color-text;
      text-align: center;
      h2 {
        font-size: 72px;
        margin-bottom: 42px;
      }
      h4 {
        font-size: 28px;
        margin-bottom: 0;
        font-weight: normal;
      }
    }
  }
}

.concept-connect {
  height: 1080px;
  padding: 0 122px;
  .flexbox-item {
    padding: 88px;
  }
}

.recruit-connect {
  padding: 110px 0;

  .recruit-connect-ul {
    width: 1500px;
    margin: 0 auto;
    color: $color-text;
    li {
      background: rgba(255, 255, 255, 0.05);
      min-height: 110px;
      padding: 0 40px;
      margin-bottom: 30px;
      cursor: pointer;
      &.active {
        background: rgba(29, 191, 115, 0.08);
      }
      &:hover {
        background: rgba(255, 255, 255, 0.02);
      }
      &.active:hover {
        background: rgba(29, 191, 115, 0.16);
      }
      .recruit-connect-title {
        line-height: 110px;

        h2 {
          margin-right: 50px;
        }
        span.flexbox-item {
          font-size: 18px;
        }
        .openicon {
          width: 36px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          font-size: 14px;
          border: 2px solid rgba(255, 255, 255, 0.5);
          color: rgba(255, 255, 255, 0.5);
          border-radius: 50%;
          display: inline-block;
          &.active {
            transform: rotate(180deg);
            -ms-transform: rotate(180deg); /* IE 9 */
            -moz-transform: rotate(180deg); /* Firefox */
            -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
            -o-transform: rotate(180deg); /* Opera */
          }
        }
      }
      &.active .recruit-connect-view {
        padding: 30px 0;
        height: auto;
      }

      .recruit-connect-view {
        padding: 0;
        height: 0;
        overflow: hidden;
        .recruit-connect-item {
          margin-bottom: 40px;
          h4 {
            font-size: 16px;
            color: rgba(255, 255, 255, 0.5);
            margin-bottom: 20px;
          }
          p {
            font-size: 14px;
            line-height: 24px;
            color: rgba(255, 255, 255, 0.9);
          }
        }
      }
    }
  }
}

@media only screen and (max-width: $mobile-width) {
  .contactus-us {
    height: 5.91rem;
    .contactus-us-view {
      width: 100%;
      padding-top: 2.4rem;
      .contactus-us-infor {
        h2 {
          font-size: 0.42rem;
          margin-bottom: 0.36rem;
        }
        h4 {
          font-size: 0.24rem;
        }
      }
    }
  }

  .concept-connect {
    display: block;
    padding: 0;
    width: 86.4%;
    height: auto;
    margin: 0 auto;
    margin-top: 0.91rem;
    .flexbox-item {
      padding: 0;
      .w-title-box.left {
        text-align: center;
      }
      img {
        max-width: 100%;
      }
    }
  }

  .recruit-connect {
    width: 86.4%;
    margin: 0 auto;
    padding-top: 1.3rem;
    padding-bottom: 0.91rem;
    .recruit-connect-ul {
      width: 100%;
      li {
        min-height: 0.8rem;
        padding: 0 0.27rem;
        margin-bottom: 0.27rem;
        &.active .recruit-connect-view {
          padding: 0.36rem 0;
          .recruit-connect-item {
            margin-bottom: 0.36rem;
            h4 {
              font-size: 0.22rem;
              margin-bottom: 0.22rem;
            }
            p {
              line-height: 0.33rem;
              font-size: 0.22rem;
            }
          }
        }
        .recruit-connect-title {
          line-height: 0.8rem;
          h2 {
            margin-right: 0.27rem;
            font-size: 0.27rem;
          }
          span.flexbox-item {
            font-size: 0.2rem;
          }
          .openicon {
            width: 0.29rem;
            height: 0.29rem;
            line-height: 0.29rem;
            font-size: 0.07rem;
            border: 1px solid rgba(255, 255, 255, 0.5);
          }
        }
      }
    }
  }
}
</style>
